export var FORM_INPUTS = [
    {
        name: 'funnel_id',
        label: 'extraSettings.funnels.name',
        placeholder: 'extraSettings.funnels.name',
        description: 'extraSettings.funnels.description',
    },
    {
        name: 'responsible_person_id',
        label: 'extraSettings.responsiblePerson.label',
        placeholder: 'extraSettings.responsiblePerson.placeholder',
        description: 'extraSettings.responsiblePerson.description',
    },
];
